import { z, ZodTypeDef } from 'zod';

export const dto = <TInput, Def extends ZodTypeDef, TOutput, TError>(
  success: z.ZodSchema<TInput, Def, TOutput>,
  error: z.ZodSchema<TError>,
) => {
  return z.discriminatedUnion('success', [
    z.object({ success: z.literal(true), data: success }),
    z.object({ success: z.literal(false), error: error }),
  ]);
};
